import {
  DONATION_DECISION_STEP,
  type DonationDecisionStep,
} from '../constants/marketPromotion.constants';
import type { MpApprovalDetail } from '../types/marketPromotion.types';
import { ApproveDonationForm } from './ApproveDonationForm';
import { RecommendDonationForm } from './RecommendDonationForm';

interface DonationDecisionFormProps {
  step: DonationDecisionStep;
  donation: MpApprovalDetail;
  onClose: () => void;
  onDone: () => void;
}

export function DonationDecisionForm({
  step,
  donation,
  onClose,
  onDone,
}: DonationDecisionFormProps) {
  if (step === DONATION_DECISION_STEP.recommend) {
    return <RecommendDonationForm donation={donation} onClose={onClose} onDone={onDone} />;
  }
  return <ApproveDonationForm donation={donation} onClose={onClose} onDone={onDone} />;
}
